import React, { useState, useEffect } from 'react';

const CountdownSection = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  // Countdown timer
  useEffect(() => {
    const targetDate = new Date('2026-10-31T09:00:00').getTime();
    
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const difference = targetDate - now;
      
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((difference % (1000 * 60)) / 1000)
        });
      } else {
        // Event has passed - show zeros
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        });
      }
    }, 1000);
    
    return () => clearInterval(timer);
  }, []);

  return (
    <div>
      <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-white/20 shadow-lg max-w-5xl mx-auto">
        <div className="text-center mb-6">
          <h2 className="text-3xl md:text-4xl font-bold mb-2 text-white">
            Countdown to Open House
          </h2>
          <p className="text-lg text-gray-300">Join Us on October 31, 2026, at 9:00 AM</p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          <div className="bg-white/10 rounded-xl p-4 text-center border border-white/15">
            <div className="text-3xl md:text-4xl font-bold text-white mb-1 font-mono">
              {String(timeLeft.days).padStart(2, '0')}
            </div>
            <div className="text-sm md:text-base font-medium text-gray-300">Days</div>
          </div>
          
          <div className="bg-white/10 rounded-xl p-4 text-center border border-white/15">
            <div className="text-3xl md:text-4xl font-bold text-white mb-1 font-mono">
              {String(timeLeft.hours).padStart(2, '0')}
            </div>
            <div className="text-sm md:text-base font-medium text-gray-300">Hours</div>
          </div>
          
          <div className="bg-white/10 rounded-xl p-4 text-center border border-white/15">
            <div className="text-3xl md:text-4xl font-bold text-white mb-1 font-mono">
              {String(timeLeft.minutes).padStart(2, '0')}
            </div>
            <div className="text-sm md:text-base font-medium text-gray-300">Minutes</div>
          </div>
          
          <div className="bg-white/10 rounded-xl p-4 text-center border border-white/15">
            <div className="text-3xl md:text-4xl font-bold text-white mb-1 font-mono">
              {String(timeLeft.seconds).padStart(2, '0')}
            </div>
            <div className="text-sm md:text-base font-medium text-gray-300">Seconds</div>
          </div>
        </div>
        
        <div className="mt-6 text-center">
          <div className="grid grid-cols-3 gap-4 max-w-xs mx-auto text-center">
            <div className="bg-white/8 rounded-lg p-3">
              <div className="text-lg font-bold text-white">16</div>
              <div className="text-xs text-gray-400">Departments</div>
            </div>
            <div className="bg-white/8 rounded-lg p-3">
              <div className="text-lg font-bold text-white">11</div>
              <div className="text-xs text-gray-400">Centers</div>
            </div>
            <div className="bg-white/8 rounded-lg p-3">
              <div className="text-lg font-bold text-white">6</div>
              <div className="text-xs text-gray-400">Schools</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountdownSection;